import { OrganizationFragment, UserFragment } from '@/graphql/generated/graphql';
import { ICurrentUser } from '@/graphql/operations/user';
import dayjs from 'dayjs';

export default function defineUserQueryData(user: UserFragment, isAuthenticated: boolean): ICurrentUser {
  const zoneName = dayjs.tz.guess();
  return {
    ...user,
    isAuthenticated,
    organization: user.organization as OrganizationFragment,
    permissions: {
      isAdmin: user.isAdmin,
    },
    timezone: {
      utc: dayjs().tz(zoneName).offsetName('short'),
      longName: dayjs().tz(zoneName).offsetName('long'),
      name: zoneName,
    },
  };
}
